const ProfilOverviewSearch = {
    idSekolah: null,
    idKelas: null,
    idKelasParalel: null,
    idProfilCbt: null,
    kodeTahunAjaran: null
}

export default ProfilOverviewSearch;